var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#9651FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3964 13.9648C12.3047 13.9557 12.1947 13.9557 12.0939 13.9648C9.91219 13.8915 8.17969 12.104 8.17969 9.90398C8.17969 7.65815 9.99469 5.83398 12.2497 5.83398C14.4955 5.83398 16.3197 7.65815 16.3197 9.90398C16.3105 12.104 14.578 13.8915 12.3964 13.9648Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.041 7.66602C20.8194 7.66602 22.2494 9.10518 22.2494 10.8743C22.2494 12.6068 20.8744 14.0185 19.1602 14.0827C19.0869 14.0735 19.0044 14.0735 18.9219 14.0827",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81414 17.346C5.59581 18.831 5.59581 21.251 7.81414 22.7268C10.335 24.4135 14.4691 24.4135 16.99 22.7268C19.2083 21.2418 19.2083 18.8218 16.99 17.346C14.4783 15.6685 10.3441 15.6685 7.81414 17.346Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 22.334C21.4725 22.1965 22.0958 21.9307 22.6092 21.5365C24.0392 20.464 24.0392 18.6948 22.6092 17.6223C22.105 17.2373 21.4908 16.9807 20.84 16.834",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/CustomerIcon.6b0a6fb8d961811e079dd98898a35f21.svg";
export { ForwardRef as ReactComponent };